<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button v-if="hasSetting2" type="primary" @click="onSetting2">点价数量设置</el-button>
        <el-button v-if="hasSetting" type="primary" @click="onSetting">点价时间设置</el-button>
        <el-button v-if="hasExport" type="primary" @click="onDownExcel">导出</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
               label-width="100px">
        <el-form-item label="客户名称" prop="userName">
          <!-- <el-select clearable filterable v-model="searchForm.userId" placeholder="请选择客户名称">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select> -->
          <el-input clearable v-model="searchForm.userName" placeholder="请输入客户名称" />
        </el-form-item>
        <el-form-item label="合同编号" prop="contractNo">
          <el-input clearable v-model="searchForm.contractNo" placeholder="请输入合同编号" />
        </el-form-item>
        <el-form-item label="订单编号" prop="orderNumber">
          <el-input clearable v-model='searchForm.orderNumber' placeholder="请输入订单编号" />
        </el-form-item>

        <el-form-item label="商品名称" prop="specName">
          <el-input clearable v-model="searchForm.specName" placeholder="请输入商品名称" />
        </el-form-item>

        <el-form-item label="订单状态" prop="orderStatus">
          <el-select clearable filterable v-model="searchForm.orderStatus" placeholder="请选择订单状态">
            <el-option v-for="(item, index) of orderStatusList" :value="item.value" :label="item.label"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单日期" prop="dateArr">
          <el-date-picker v-model="dateArr" type="daterange" range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table v-if="orderType === '1'" key="1" size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="200" label="合同编号" prop="contractNo"></el-table-column>
        <!-- 修改后的订单编号列 -->
        <el-table-column min-width="230" label="订单编号" prop="orderNumber">
          <template v-slot:header>
            <span @click="handleOrderNumberSort" style="cursor: pointer;">
              订单编号
              <i v-if="numberOrder === 1" class="el-icon-arrow-up ml-1"></i>
              <i v-if="numberOrder === ''" class="el-icon-arrow-down ml-1"></i>
            </span>
          </template>
          <template v-slot="{ row }">
            <el-button type="text"
                       @click="$router.push('/orderManage/deliveryOrder?orderId=' + row.orderId + '&orderType=' + orderType)">{{
                row.orderNumber }}</el-button>
            <el-button v-if="row.orderNumber" type="text" @click.stop="handleCopyOrderNo(row.orderNumber)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="提货日期" prop="pickupDate">
          <template v-slot="{ row }">
            <span>{{ row.pickupDate || "--" }}</span>
            <el-button type="text" v-if="hasEditDate && ['1', '2'].includes(row.orderStatus)"
                       @click="onEditDate(row)">修改</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="220" show-overflow-tooltip label="商品名称" prop="specName"></el-table-column>
        <el-table-column v-if="orderType === '1'" min-width="120" label="锁定单价(元)" prop="lockedPrice">
          <template v-slot="{ row }">
            {{ row.lockedPrice || "--" }}
          </template>
        </el-table-column>
        <el-table-column v-if="orderType === '2'" min-width="120" label="暂定单价(元)" prop="lockedPrice">
          <template v-slot="{ row }">
            <span>{{ row.lockedPrice - row.priceDiff }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="确认价" v-if="orderType == '2'" prop="lockedPrice">
          <template v-slot="{ row }">
            {{ (orderType === '2' && row.parentOrderId) ? row.lockedPrice : '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" :label="orderType == '1' ? '锁定数量' : '总数'"
                         prop="orderQuantity"></el-table-column>
        <el-table-column min-width="120" label="已用数量" prop="usedQuantity"></el-table-column>
        <el-table-column min-width="180" v-if="orderType === '1'" label="提货进行中数量"
                         prop="usedAddQuantity"></el-table-column>
        <el-table-column min-width="120" v-if="orderType === '1'" label="可用数量" prop="kyQuantity"></el-table-column>
        <!-- <el-table-column min-width="120" label="价格差(元)" prop="priceDiff"></el-table-column> -->
        <el-table-column min-width="120" label="保证金比例" prop="orderDeposit">
          <template v-slot="{ row }">
            {{ row.orderDeposit + "%" }}
          </template>
        </el-table-column>
        <el-table-column min-width="220" label="锁定保证金(充值/收益)" prop="lockedDeposit">
          <template v-slot="{ row }">
            {{ `${row.lockedDepositDeposit} / ${row.lockedPickupDeposit}` }}
          </template>
        </el-table-column>
        <!-- <el-table-column min-width="180" label="锁定保证金(充值)(元)" prop="lockedDepositDeposit"></el-table-column> -->
        <!-- <el-table-column min-width="180" label="锁定保证金(其他)(元)" prop="lockedPickupDeposit"></el-table-column> -->
        <el-table-column min-width="160" label="订单状态" prop="orderStatus">
          <template v-slot="{ row }">
            <template v-if="row.resState !== '1'">
              <el-tag type="warning">货转中</el-tag>
            </template>
            <template v-else-if="['2', '3'].includes(row.hgState)">
              <el-tag type="warning">回购中</el-tag>
            </template>
            <template v-else>
              <el-tag type="warning" v-if="row.orderStatus == '1'">待审批</el-tag>
              <el-tag type="primary" v-if="row.orderStatus == '2'">进行中</el-tag>
              <el-tag type="success" v-if="row.orderStatus == '3' && row.hgState === '4'">已回购</el-tag>
              <el-tag type="success" v-else-if="row.orderStatus == '3'">已完成</el-tag>
              <el-tag type="danger" v-if="row.orderStatus == '4'">驳回作废</el-tag>
            </template>
            <el-tag v-if="row.pickupLocked === '1'" type="danger" class="ml10"
                    title="本单暂停提货，允许点价">锁</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column width="390" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text"
                       @click="$router.push('/orderManage/detail?orderId=' + row.orderId + '&orderType=' + orderType)">详情</el-button>
            <el-button type="text" v-if="hasLockOrder && (['1', '2'].includes(row.orderStatus) || row.pickupLocked === '1')"
                       :disabled="pickupLockSubmitting" @click="onPickupLock(row)">{{ row.pickupLocked === '1' ? '解锁' : '锁定' }}</el-button>
            <el-button type="text" v-if="row.orderStatus == 1 && hasApproval" @click="onAppoval(row)">审批</el-button>
            <el-button type="text" v-if="!row.resPrice && row.hgState === '2' && hasApprovalHg2"
                       @click="onAppovalHgJe(row)">填写补贴金额</el-button>
            <el-button type="text" v-if="row.resPrice && row.hgState === '2' && hasApprovalHg2"
                       @click="onAppovalHg(row)">回购审批</el-button>
            <el-button type="text" v-if="row.resPrice && row.hgState === '3' && hasApprovalHg3"
                       @click="onAppovalHg(row)">回购审批</el-button>
            <el-button type="text" v-if="['2', '3'].includes(row.hgState) && row.resPrice"
                       @click="onDownExcel2(row.orderId)">导出回购单</el-button>
            <el-button type="text"
                       v-if="row.orderStatus == 2 && hasTransfer && row.resState === '1'"
                       @click="onTransfer(row)">货权转让</el-button>
            <el-button type="text"
                       v-if="row.orderStatus == 2 && hasEditNum && row.resState === '1' && !row.parentOrderId"
                       @click="onEditNumr(row)">提货配置</el-button>
            <el-button type="text" v-if="row.orderStatus == 2 && hasComplete && row.resState === '1'"
                       @click="onComplete(row)">完成</el-button>
            <el-button type="text" v-if="row.parentOrderId && row.orderStatus === '2' && hasReturn"
                       @click="onReturn(row)">退回</el-button>
            <el-button v-if="hasDel && row.resState === '1'" type="text" @click="deleteRow(row.orderId)"
                       class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-if="orderType === '2'" key="2" size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="200" label="合同编号" prop="contractNo"></el-table-column>
        <el-table-column min-width="230" label="订单编号" prop="orderNumber">
          <template v-slot:header>
            <span @click="handleOrderNumberSort" style="cursor: pointer;">
              订单编号
              <i v-if="numberOrder === 1" class="el-icon-arrow-up ml-1"></i>
              <i v-if="numberOrder === ''" class="el-icon-arrow-down ml-1"></i>
            </span>
          </template>
          <template v-slot="{ row }">
            <el-button type="text"
                       @click="$router.push('/orderManage/deliveryOrder?orderId=' + row.orderId + '&orderType=' + orderType)">{{
                row.orderNumber }}</el-button>
            <el-button v-if="row.orderNumber" type="text" @click.stop="handleCopyOrderNo(row.orderNumber)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="220" show-overflow-tooltip label="商品名称" prop="specName"></el-table-column>
        <el-table-column min-width="120" label="暂定单价(元)" prop="lockedPrice">
          <template v-slot="{ row }">
            <span v-if="!row.parentOrderId">{{ row.lockedPrice - row.priceDiff }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="合同总数" prop="lockedPrice">
          <template v-slot="{ row }">
            <span v-if="!row.parentOrderId">{{ (parseInt(row.orderQuantity) || 0) + (parseInt(row.ydQuantity) || 0)
              }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="已点数量" prop="ydQuantity">
          <template v-slot="{ row }">
            <span v-if="!row.parentOrderId">{{ row.ydQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="未点数量" prop="orderQuantity">
          <template v-slot="{ row }">
            <span v-if="!row.parentOrderId">{{ row.orderQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="点价单价" prop="lockedPrice">
          <template v-slot="{ row }">
            <span v-if="row.parentOrderId">{{ row.lockedPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="点价总数" prop="orderQuantity">
          <template v-slot="{ row }">
            <span v-if="row.parentOrderId">{{ row.orderQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="已提数量" prop="usedQuantity"></el-table-column>
        <el-table-column min-width="120" label="未提数量">
          <template v-slot="{ row }">
            {{ parseFloat((row.orderQuantity - row.usedQuantity).toFixed(3)) }}
          </template>
        </el-table-column>

        <el-table-column v-if="orderType === '1'" min-width="120" label="锁定单价(元)" prop="lockedPrice">
          <template v-slot="{ row }">
            {{ row.lockedPrice || "--" }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="保证金比例" prop="orderDeposit">
          <template v-slot="{ row }">
            {{ row.orderDeposit + "%" }}
          </template>
        </el-table-column>
        <el-table-column min-width="220" label="锁定保证金(充值/收益)" prop="lockedDeposit">
          <template v-slot="{ row }">
            {{ `${row.lockedDepositDeposit} / ${row.lockedPickupDeposit}` }}
          </template>
        </el-table-column>
        <!-- <el-table-column min-width="180" label="锁定保证金(充值)(元)" prop="lockedDepositDeposit"></el-table-column> -->
        <!-- <el-table-column min-width="180" label="锁定保证金(其他)(元)" prop="lockedPickupDeposit"></el-table-column> -->
        <el-table-column min-width="140" label="提货日期" prop="pickupDate">
          <template v-slot="{ row }">
            <span>{{ row.pickupDate || "--" }}</span>
            <el-button type="text" v-if="hasEditDate && ['1', '2'].includes(row.orderStatus)"
                       @click="onEditDate(row)">修改</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="140" label="创建时间" prop="ctime"></el-table-column>
        <el-table-column min-width="160" label="订单状态" prop="orderStatus">
          <template v-slot="{ row }">
            <template v-if="row.resState !== '1'">
              <el-tag type="warning">货转中</el-tag>
            </template>
            <template v-else-if="['2', '3'].includes(row.hgState)">
              <el-tag type="warning">回购中</el-tag>
            </template>
            <template v-else>
              <el-tag type="warning" v-if="row.orderStatus == '1'">待审批</el-tag>
              <el-tag type="primary" v-if="row.orderStatus == '2'">进行中</el-tag>
              <el-tag type="success" v-if="row.orderStatus == '3' && row.hgState === '4'">已回购</el-tag>
              <el-tag type="success" v-else-if="row.orderStatus == '3'">已完成</el-tag>
              <el-tag type="danger" v-if="row.orderStatus == '4'">驳回作废</el-tag>
            </template>
            <el-tag v-if="row.pickupLocked === '1'" class="ml10" type="danger"
                    title="本单暂停提货，允许点价">锁</el-tag>
          </template>
        </el-table-column>

        <el-table-column width="390" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text"
                       @click="$router.push('/orderManage/detail?orderId=' + row.orderId + '&orderType=' + orderType)">详情</el-button>
            <el-button type="text" v-if="hasLockOrder && (['1', '2'].includes(row.orderStatus) || row.pickupLocked === '1')"
                       :disabled="pickupLockSubmitting" @click="onPickupLock(row)">{{ row.pickupLocked === '1' ? '解锁' : '锁定' }}</el-button>
            <el-button type="text" v-if="row.orderStatus == 1 && hasApproval" @click="onAppoval(row)">审批</el-button>
            <el-button type="text" v-if="!row.resPrice && row.hgState === '2' && hasApprovalHg2"
                       @click="onAppovalHgJe(row)">填写补贴金额</el-button>
            <el-button type="text" v-if="row.resPrice && row.hgState === '2' && hasApprovalHg2"
                       @click="onAppovalHg(row)">回购审批</el-button>
            <el-button type="text" v-if="row.resPrice && row.hgState === '3' && hasApprovalHg3"
                       @click="onAppovalHg(row)">回购审批</el-button>
            <el-button type="text" v-if="['2', '3'].includes(row.hgState) && row.resPrice"
                       @click="onDownExcel2(row.orderId)">导出回购单</el-button>
            <el-button type="text"
                       v-if="row.orderStatus == 2 && hasTransfer && row.resState === '1'"
                       @click="onTransfer(row)">货权转让</el-button>
            <el-button type="text"
                       v-if="row.orderStatus == 2 && hasEditNum && row.resState === '1' && !row.parentOrderId"
                       @click="onEditNumr(row)">提货配置</el-button>
            <el-button type="text" v-if="row.orderStatus == 2 && hasComplete && row.resState === '1'"
                       @click="onComplete(row)">完成</el-button>
            <el-button type="text" v-if="row.parentOrderId && row.orderStatus === '2' && hasReturn"
                       @click="onReturn(row)">退回</el-button>
            <el-button v-if="hasDel && row.resState === '1'" type="text" @click="deleteRow(row.orderId)"
                       class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>

    <el-dialog title="点击时间设置" class="global-dialog" :visible.sync="settingVisible" width="520px">
      <div class="setting-content">
        <el-form :model="settingForm" :rules="settingRules" ref="settingForm">
          <el-form-item label="点价状态" prop="yxStatus">
            <el-radio-group v-model="settingForm.yxStatus">
              <el-radio label="1">正常</el-radio>
              <el-radio label="2">禁止下单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="settingForm.yxStatus !== '2'" label="点价时间" prop="yxTime">
            <el-time-picker :picker-options="{ format: 'HH:mm' }" @change="timeChange" value-format="HH:mm" is-range
                            v-model="timeArr" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间"
                            placeholder="选择时间范围">
            </el-time-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settingVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSetting">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="点击数量设置" class="global-dialog" :visible.sync="settingVisible2" width="520px">
      <div class="setting-content">
        <el-form :model="settingForm2" label-width="120px" :rules="settingRules2" ref="settingForm2">
          <el-form-item label="类型" prop="numId">
            <el-radio-group v-model="settingForm2.numId" @change="loadSetting2">
              <el-radio label="0">成品油</el-radio>
              <el-radio label="1">散油</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="最小数量" prop="orderMinNum">
            <el-input v-model="settingForm2.orderMinNum" placeholder="请输入最小数量"></el-input>
          </el-form-item>
          <el-form-item label="最大数量" prop="orderMaxNum">
            <el-input v-model="settingForm2.orderMaxNum" placeholder="请输入最大数量"></el-input>
          </el-form-item>
          <el-form-item label="单日最大提货量" prop="pickupMaxNum">
            <el-input v-model="settingForm2.pickupMaxNum" placeholder="请输入最大提货量"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settingVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="saveSetting2">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提货数量设置" class="global-dialog" :visible.sync="editNumVisible" width="520px">
      <div class="setting-content">
        <el-form :model="editNumForm" label-width="120px" :rules="editNumRules" ref="editNumForm">
          <el-form-item label="单日最大提货量" prop="maxNum">
            <el-input v-model="editNumForm.maxNum" placeholder="请输入最大提货量"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editNumVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveEditNum">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="退回" class="global-dialog" :visible.sync="returnVisible" width="520px">
      <div class="setting-content">
        <el-form :model="returnForm" label-width="120px" :rules="returnRules" ref="returnForm">
          <el-form-item label="退回数量" prop="orderQuantity">
            <el-input v-model="returnForm.orderQuantity" placeholder="请输入退回数量"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="returnCancel">取 消</el-button>
        <el-button type="primary" @click="returnConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="完成点价订单" class="global-dialog" :visible.sync="editStatusVisible" width="560px" :close-on-click-modal="false" :close-on-press-escape="!editStatusSubmitting" :show-close="!editStatusSubmitting">
      <div class="setting-content">
        <el-form :model="editStatusForm" :rules="editStatusRules" ref="editStatusForm" label-width="150px">
          <el-form-item label="订单编号">{{ editStatusOrderNumber }}</el-form-item>
          <el-form-item label="剩余充值保证金">{{ editStatusRecharge }} 元</el-form-item>
          <el-form-item v-if="Number(editStatusRecharge) > 0" label="充值保证金释放至" prop="depositReleaseType">
            <el-radio-group v-model="editStatusForm.depositReleaseType" :disabled="editStatusSubmitting">
              <el-radio label="1">保证金</el-radio>
              <el-radio label="3">货款</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-alert title="仅剩余充值保证金可选择释放去向，金融保证金按原类型释放。实际释放金额以提交时为准。" type="info" :closable="false"></el-alert>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="editStatusSubmitting" @click="editStatusVisible = false">取 消</el-button>
        <el-button type="primary" :loading="editStatusSubmitting" @click="saveEditStatus">确认完成</el-button>
      </span>
    </el-dialog>

    <el-dialog title="转移订单" class="global-dialog" :visible.sync="transferVisible" width="520px">
      <div class="setting-content">
        <el-form :model="transferForm" label-width="80px" :rules="transferRules" ref="transferForm">
          <el-form-item label="接收用户" prop="userName">
            <!-- <el-select :filterable="true" v-model="transferForm.userName" placeholder="请输入接收用户">
              <el-option v-for="item in userList" :key="item.userId" :label="item.userName"
                :value="item.userId"></el-option>
            </el-select> -->
            <el-input v-model="transferForm.userName" placeholder="请输入接收用户"></el-input>
          </el-form-item>
          <el-form-item prop="resPrice" label="接收单价">
            <el-input v-model="transferForm.resPrice" placeholder="请输入接收单价"></el-input>
          </el-form-item>
          <el-form-item prop="resQuantity" label="转让数量">
            <el-input v-model="transferForm.resQuantity" placeholder="请输入本次转让数量，最多三位小数"></el-input>
            <div>剩余可转数量：{{ transferAvailable }}</div>
          </el-form-item>
          <el-form-item prop="fileList" label="附件">
            <file-upload v-model="transferForm.fileList"></file-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transferVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveTransfer">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 审批 -->
    <ApprovalDialog urlType="2" :relatedId="rowId" :isChildOrder="parentOrderId !== ''" v-if='showDlg' @closeDlg="showDlg = false" @successSave="loadData"
                    :showDlg="showDlg"></ApprovalDialog>

    <!-- 回购审批 -->
    <ApprovalDialog urlType="8" :relatedId="rowId" v-if='showDlg2' @closeDlg="showDlg2 = false" @successSave="loadData"
                    :showDlg="showDlg2"></ApprovalDialog>

    <!-- 回购审批 -->
    <ApprovalDialog urlType="9" :relatedId="rowId" v-if='showDlg3' @closeDlg="showDlg3 = false" @successSave="loadData"
                    :showDlg="showDlg3"></ApprovalDialog>

    <!-- 回购审批 -->
    <ApprovalDialog urlType="10" :relatedId="rowId" v-if='showDlg4' @closeDlg="showDlg4 = false" @successSave="loadData"
                    :showDlg="showDlg4"></ApprovalDialog>

    <!-- 提货日期修改 -->
    <EditDateDlg v-if="showDateDlg" :pickupDate="pickupDate" @successSave="loadData" :orderId="rowId"
                 :showDlg.sync="showDateDlg"></EditDateDlg>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import ApprovalDialog from '@/views/bondRecord/ApprovalDialog'
import BigNumber from 'bignumber.js'
import EditDateDlg from './EditDateDlg.vue'
import { validNumber3 } from '@/utils/validator'
import { copyText } from '@/utils/utils'

export default {
  name: 'orderManage',
  mixins: [keepAlive],
  components: { ApprovalDialog, EditDateDlg },
  data() {
    return {
      settingVisible: false,
      settingVisible2: false,
      returnVisible: false,
      timeArr: ['', ''],
      settingForm: {
        yxStatus: '',
        yxTime: ''
      },
      returnForm: {
        orderId: '',
        orderQuantity: ''
      },
      returnRules: {
        orderQuantity: [
          { required: true, message: '请输入退回数量' },
          { pattern: validNumber3, message: '退回数量保留三位小数' }
        ]
      },
      settingRules: {
        yxStatus: [{ required: true, message: '请选择点价状态' }],
        yxTime: [{ required: true, message: '请选择点价时间断' }]
      },
      settingForm2: {
        numId: '', // id
        orderMinNum: '', // 最小数量
        orderMaxNum: '', // 最大数量
        pickupMaxNum: '', // 最大提货量
        isBulkOil: '' // 粮油规格
      },
      settingRules2: {
        numId: [{ required: true, message: '请选择类型' }],
        orderMinNum: [{ required: true, message: '请输入最小数量' }],
        orderMaxNum: [{ required: true, message: '请输入最大数量' }],
        pickupMaxNum: [{ required: true, message: '请输入最大提货量' }]
      },
      tableData: [],
      // 1待审核，2进行中，3已结束 4驳回作废
      orderStatusList: [
        { label: '待审批', value: '1' },
        { label: '进行中', value: '2' },
        { label: '已完成', value: '3' },
        { label: '已回购', value: '99' },
        { label: '驳回作废', value: '4' }
      ],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        userId: '',
        contractNo: '',
        userName: '',
        orderStatus: '',
        orderNumber: '',
        specName: ''
      },
      numberOrder: '',
      editStatusVisible: false,
      editStatusSubmitting: false,
      editStatusLoading: false,
      editStatusOrderNumber: '',
      editStatusRecharge: 0,
      editStatusForm: {
        orderId: '',
        depositReleaseType: '1'
      },
      editStatusRules: {
        depositReleaseType: [{ required: true, message: '请选择充值保证金释放去向', trigger: 'change' }]
      },
      dateArr: [],
      userList: [],
      showDlg: false,
      showDlg2: false,
      showDlg3: false,
      showDlg4: false,
      rowId: '',
      parentOrderId: '',
      showDateDlg: false,
      pickupDate: '',
      transferVisible: false,
      // 保留当前工单可转上限；后台审批时仍会再次校验最新余量。
      transferAvailable: '0',
      transferForm: {
        orderId: '',
        userName: '',
        resPrice: '',
        resQuantity: '',
        fileList: []
      },
      transferRules: {
        resQuantity: [
          { required: true, message: '请输入转让数量' },
          { pattern: validNumber3, message: '转让数量最多保留三位小数' },
          {
            validator: (rule, value, callback) => {
              const quantity = new BigNumber(value)
              if (!quantity.isFinite() || quantity.lte(0) || quantity.gt(this.transferAvailable)) {
                callback(new Error('转让数量须大于0且不能超过剩余可转数量'))
              } else {
                callback()
              }
            }
          }
        ],
        userName: [{ required: true, message: '请输入接收用户' }],
        resPrice: [
          { required: true, message: '请输入接收单价' },
          { pattern: validNumber3, message: '接收单价保留三位小数' }
        ]
      },
      pickupLockSubmitting: false,
      editNumVisible: false,
      editNumForm: {
        maxNum: ''
      },
      editNumRules: {
        maxNum: [
          { required: true, message: '请输入最大提货量' },
          { pattern: validNumber3, message: '最大提货量保留三位小数' }
        ]
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    },
    hasApprovalHg2() {
      return this.buttonList.includes('approvalHg2')
    },
    hasApprovalHg3() {
      return this.buttonList.includes('approvalHg3')
    },
    hasLockOrder() {
      return this.buttonList.includes('lockOrder')
    },
    hasComplete() {
      return this.buttonList.includes('complete')
    },
    hasTransfer() {
      return this.buttonList.includes('transfer')
    },
    hasSetting() {
      return this.buttonList.includes('setting')
    },
    hasSetting2() {
      return this.buttonList.includes('setting2')
    },
    hasExport() {
      return this.buttonList.includes('export')
    },
    hasEditDate() {
      return this.buttonList.includes('editDate')
    },
    hasReturn() {
      return this.buttonList.includes('return')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasEditNum() {
      return this.buttonList.includes('editNum')
    },
    orderType() {
      console.log(' this.$route.query.orderType : ', this.$route.query.orderType)
      return this.$route.query.orderType || '1'
    }
  },
  created() {
    this.loadUserList()
    this.loadData()
    console.log('this.buttonList', this.buttonList)
  },
  watch: {
    orderType(newV, oldV) {
      if (newV !== oldV) {
        this.onReset()
        this.onSearch()
      }
    }
  },
  methods: {
    async onPickupLock(row) {
      if (this.pickupLockSubmitting) return
      const pickupLocked = row.pickupLocked === '1' ? '0' : '1'
      const action = pickupLocked === '1' ? '锁定' : '解锁'
      const message = pickupLocked === '1'
        ? '锁定后仅本单暂停提货，仍可继续点价，关联订单及子订单不受影响。确认锁定？'
        : '解锁后本单恢复提货。确认解锁？'
      this.pickupLockSubmitting = true
      try {
        await this.$confirm(message, action + '订单', { type: 'warning' })
        await this.$axios.post(this.$apis.orderManage.updatePickupLocked, { orderId: row.orderId, pickupLocked })
        this.$message.success(action + '成功')
        this.loadData()
      } catch (error) {
        // 取消不提交；接口错误由统一响应拦截器提示。
      } finally {
        this.pickupLockSubmitting = false
      }
    },
    async handleCopyOrderNo(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    // 新增排序处理方法
    handleOrderNumberSort() {
      if (this.numberOrder === '') {
        // 第一次点击：升序排序
        this.numberOrder = 1
      } else if (this.numberOrder === 1) {
        // 第二次点击：恢复默认排序
        this.numberOrder = ''
      }
      // 重新加载数据
      this.page = 1
      this.loadData()
    },

    // 原有方法
    onTransfer(row) {
      // 每次打开都重新输入本次数量，避免沿用上一次申请或默认全量转出。
      this.transferAvailable = new BigNumber(row.orderQuantity || 0).minus(row.usedQuantity || 0).toFixed(3)
      this.transferForm.orderId = row.orderId
      this.transferVisible = true
      this.$nextTick(() => {
        this.$refs.transferForm.resetFields()
      })
    },
    onEditNumr(row) {
      this.editNumVisible = true
      this.$nextTick(() => {
        this.$refs.editNumForm.resetFields()
        this.editNumForm.orderId = row.orderId
        this.editNumForm.maxNum = row.maxNum
      })
    },
    saveEditNum() {
      this.$refs.editNumForm.validate().then(() => {
        this.$axios.post(this.$apis.orderManage.updateYxPriceOrderNum, this.editNumForm).then(res => {
          this.editNumVisible = false
          this.loadData()
        })
      })
    },
    saveTransfer() {
      this.$refs.transferForm.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.orderManage.insertYxPriceOrderRes, this.transferForm).then(res => {
            this.transferVisible = false
            this.loadData()
          })
        }
      })
    },
    onComplete(row) {
      if (this.editStatusLoading || this.editStatusSubmitting || this.editStatusVisible) return
      this.editStatusLoading = true
      this.$axios.get(this.$apis.orderManage.selectYxPriceOrderByOrderId, {
        params: { orderId: row.orderId }
      }).then(order => {
        if (String(order.orderStatus) !== '2') {
          this.$message.warning('仅进行中的点价订单可以完成，请刷新列表')
          return
        }
        this.editStatusForm = { orderId: order.orderId, depositReleaseType: '1' }
        this.editStatusOrderNumber = order.orderNumber
        this.editStatusRecharge = order.lockedDepositDeposit || 0
        if (Number(this.editStatusRecharge) > 0) {
          this.editStatusVisible = true
          this.$nextTick(() => this.$refs.editStatusForm.clearValidate())
        } else {
          this.$confirm('确认完成该订单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.editStatusVisible = false
            this.$axios.post(this.$apis.orderManage.endYxPriceOrderDate, this.editStatusForm).then(res => {
              this.editStatusVisible = false
              this.loadData()
            })
          })
        }
      }).finally(() => {
        this.editStatusLoading = false
      })
    },

    onReturn(row) {
      if (this.orderType === '1') {
        this.returnForm.orderId = row.orderId
        this.returnVisible = true
      } else if (this.orderType === '2') {
        this.$confirm('确认退回该订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post(this.$apis.orderManage.backYxPriceOrder, {
            orderId: row.orderId
          }).then(res => {
            // this.$message.success('退回成功')
            this.loadData()
          })
        })
      }
    },
    returnConfirm() {
      this.$refs.returnForm.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.orderManage.backYxPriceOrder, this.returnForm).then(res => {
            this.returnVisible = false
            this.loadData()
          })
        }
      })
    },
    returnCancel() {
      this.returnVisible = false
      this.$refs.returnForm.resetFields()
    },
    saveEditStatus() {
      if (this.editStatusSubmitting) return
      this.$refs.editStatusForm.validate(valid => {
        if (!valid) return
        this.editStatusSubmitting = true
        this.$axios.post(this.$apis.orderManage.endYxPriceOrderDate, {
          orderId: this.editStatusForm.orderId,
          depositReleaseType: this.editStatusForm.depositReleaseType
        }).then(() => {
          this.editStatusVisible = false
          this.$message.success('点价订单已完成')
          this.loadData()
        }).finally(() => {
          this.editStatusSubmitting = false
        })
      })
    },
    deleteRow(orderId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.orderManage.deleteYxPriceOrder, {
          orderId
        }).then(() => {
          this.loadData()
        })
      })
    },
    onEditDate(row) {
      this.pickupDate = row.pickupDate || ''
      this.rowId = row.orderId
      this.showDateDlg = true
    },
    onSetting() {
      this.settingVisible = true
      this.loadSetting()
    },
    onSetting2() {
      this.settingVisible2 = true
      this.loadSetting2(0)
    },
    timeChange(data) {
      if (data && data.length > 0) {
        this.settingForm.yxTime = data[0] + '-' + data[1]
      } else {
        this.settingForm.yxTime = ''
      }
    },
    loadSetting() {
      this.$axios.get(this.$apis.orderManage.selectYxStatus).then(res => {
        if (res.yxTime) {
          this.timeArr = res.yxTime.split('-')
        }
        this.settingForm = res
      })
    },
    loadSetting2(isBulkOil) {
      this.$axios.get(this.$apis.orderManage.selectYxPriceNumByNumId, {
        numId: isBulkOil
      }).then(res => {
        this.settingForm2 = res
      })
    },
    saveSetting() {
      this.$refs.settingForm.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.orderManage.updateYxStatus, this.settingForm).then(res => {
            this.settingVisible = false
          })
        }
      })
    },
    saveSetting2() {
      this.$refs.settingForm2.validate(valid => {
        if (valid) {
          this.$axios.post(this.$apis.orderManage.updateYxPriceNum, this.settingForm2).then(res => {
            this.settingVisible2 = false
          })
        }
      })
    },
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      let startDate = null
      let endDate = null
      if (this.dateArr && this.dateArr.length > 0) {
        startDate = this.dateArr[0]
        endDate = this.dateArr[1]
      }
      const obj = JSON.parse(JSON.stringify(this.searchForm))
      if (obj.orderStatus === '99') {
        obj.orderStatus = '3'
        obj.hgState = '4'
      }
      this.$axios.post(this.$apis.orderManage.exportYxPriceOrder, {
        ...obj,
        startDate,
        endDate
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const disposition = res.headers['content-disposition']
          const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    onDownExcel2(orderId) {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.orderManage.txHgPdf, {
        orderId
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const contentDisposition = res.headers['content-disposition']
          let fileName = '回购单.pdf'
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1]
            }
          }
          this.downloadFile2(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile2(data, fileName) {
      const blob = new Blob([data], { type: 'application/pdf' })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    },
    onAppoval(row) {
      this.rowId = row.orderId
      this.parentOrderId = row.parentOrderId || ''
      this.showDlg = true
    },
    onAppovalHg(row) {
      this.rowId = row.orderId
      if (row.hgState === '2') {
        this.showDlg2 = true
      } else {
        this.showDlg3 = true
      }
    },
    onAppovalHgJe(row) {
      this.rowId = row.orderId
      this.showDlg4 = true
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '3' }).then(res => {
        this.userList = res.list || []
      })
    },
    // 修改后的loadData方法
    loadData() {
      const obj = JSON.parse(JSON.stringify(this.searchForm))
      if (obj.orderStatus === '99') {
        obj.orderStatus = '3'
        obj.hgState = '4'
      }
      const params = {
        page: this.page,
        ...obj,
        orderType: this.orderType,
        numberOrder: this.numberOrder // 添加排序参数
      }
      console.log('params', params)
      if (this.dateArr && this.dateArr.length > 0) {
        params.startDate = this.dateArr[0]
        params.endDate = this.dateArr[1]
      } else {
        params.startDate = undefined
        params.endDate = undefined
      }
      this.loading = true
      this.$axios.get(this.$apis.orderManage.selectYxPriceOrderByPage, params).then(res => {
        res.list.forEach(item => {
          const orderQuantity = new BigNumber(item.orderQuantity || 0)
          const usedQuantity = new BigNumber(item.usedQuantity || 0)
          const num = orderQuantity.minus(usedQuantity)
          item.kyQuantity = Number(num.toFixed(3))
        })
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    // 修改后的重置方法
    onReset() {
      this.dateArr = []
      this.numberOrder = '' // 重置排序状态
      this.$refs.formData.resetFields()
      this.onSearch()
    }
  }
}
</script>

<style scoped lang="scss">
.setting-content {
  padding: 20px;
}
</style>
